import React, { useEffect, useState } from "react";
import "../../../../assets/styles/publicResult.scss";
import {
  getAverageBySongs,
  getResultClassName,
  getTotalBySongs,
} from "../../../../utils/scoreUtils";
import { GroupData } from "@/types/GroupData";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../firebase";

const EO24: React.FC = () => {
  const [groups, setGroups] = useState<GroupData[]>([]);

  useEffect(() => {
    const fetchGroups = async () => {
      const snapshot = await getDocs(collection(db, "groups"));
      const fetchedGroups: GroupData[] = snapshot.docs.map((doc) => ({
        ...(doc.data() as GroupData),
        id: doc.id,
      }));

      const filtered = fetchedGroups.filter((group) => {
        const year = group.createdAt?.toDate?.().getFullYear?.();
        return (
          year === 2025 &&
          group.entryClass === "EvaluationOnly" &&
          !group.isDeleted
        );
      });

      setGroups(filtered);
    };

    fetchGroups();
  }, []);

  return (
    <div className="main">
      <div className="result-area">
        <h1>
          Official Scoring Summary
          <br />
          Japan Barbershop Convention 2025 Evaluation Only
          <br />
          Yokohama; August 23, 2025
        </h1>

        <table className="result-table">
          <thead>
            <tr>
              <th className="text-left head-group">Group</th>
              <th className="text-left">Songs</th>
              <th>MUS</th>
              <th>PER</th>
              <th>SNG</th>
              <th>Total</th>
            </tr>
          </thead>
          {groups.map((group, index) => (
            <tbody
              key={group.id}
              className={index % 2 === 0 ? "group-even" : "group-odd"}
            >
              <tr className="tr-head">
                <td className="text-left font-bold">{group.groupName}</td>
                <td className="text-left font-bold total-point">
                  {getTotalBySongs(group, {}, false, [1, 2])}
                </td>
                <td className="font-bold">
                  {getAverageBySongs(group, {}, false, [1, 2], ["Mus"])}
                </td>
                <td className="font-bold">
                  {getAverageBySongs(group, {}, false, [1, 2], ["Per"])}
                </td>
                <td className="font-bold">
                  {getAverageBySongs(group, {}, false, [1, 2], ["Sng"])}
                </td>
                <td className="font-bold">
                  {getAverageBySongs(group, {}, false, [1, 2])}
                </td>
              </tr>
              <tr>
                <td></td>
                <td className="text-left">
                  {group.songName1}
                  <span className="arranged">{group.songArranged1}</span>
                </td>
                <td
                  className={getResultClassName(
                    "Mus",
                    "songPenaltyMus1",
                    false,
                    group,
                    {},
                  )}
                >
                  {group.songResultMus1}
                </td>
                <td
                  className={getResultClassName(
                    "Per",
                    "songPenaltyPer1",
                    false,
                    group,
                    {},
                  )}
                >
                  {group.songResultPer1}
                </td>
                <td
                  className={getResultClassName(
                    "Sng",
                    "songPenaltySng1",
                    false,
                    group,
                    {},
                  )}
                >
                  {group.songResultSng1}
                </td>
                <td>{getAverageBySongs(group, {}, false, [1])}</td>
              </tr>
              <tr className="tr-foot">
                <td></td>
                <td className="text-left">
                  {group.songName2}
                  <span className="arranged">{group.songArranged2}</span>
                </td>
                <td
                  className={getResultClassName(
                    "Mus",
                    "songPenaltyMus2",
                    false,
                    group,
                    {},
                  )}
                >
                  {group.songResultMus2}
                </td>
                <td
                  className={getResultClassName(
                    "Per",
                    "songPenaltyPer2",
                    false,
                    group,
                    {},
                  )}
                >
                  {group.songResultPer2}
                </td>
                <td
                  className={getResultClassName(
                    "Sng",
                    "songPenaltySng2",
                    false,
                    group,
                    {},
                  )}
                >
                  {group.songResultSng2}
                </td>
                <td>{getAverageBySongs(group, {}, false, [2])}</td>
              </tr>
            </tbody>
          ))}
        </table>

        <div className="info">
          <h2>Panel</h2>
          <p>ADM: Steve Scott</p>
          <p>MUS: Mark Hale</p>
          <p>PER: Sean Devine</p>
          <p>SNG: Ryan Wisniewski</p>
        </div>
      </div>
    </div>
  );
};

export default EO24;
